// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37eq7","content":"styles_content__1UMcc","row":"styles_row__l3A-4","footer":"styles_footer__30qNW","phraseLength":"styles_phraseLength__2bU6v"};